<div class="content-wrapper container-xxl p-0">
  <div class="content-body" style="position: relative;">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

  </div>
</div>
